/*
 * Login component to handle Custom UI user login
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2023 Gallagher Bassett Services, Inc.
 *
 */

import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { UiConfig, User } from 'app/shared/models';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { FormGroup } from "@angular/forms";

@Component ( {
    selector: 'reporter-custom-ui-config-login',
    templateUrl: './custom-ui-config-login.component.html',
    styleUrls: ['./custom-ui-config-login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
} )
export class CustomUiConfigLoginComponent implements OnInit {
  @Input () uiConfig: UiConfig;
  @Input () isAuthenticated: boolean;
  @Input () sso401: boolean;
  @Input () currentUser: User;
  @Input () gbru: any;
  @Input () loginForm: FormGroup;
  @Input () failed: boolean;
  @Input () mfaNoticeEnabled = false;
  @Input () customerMessageError: string;
  @Output () login = new EventEmitter<boolean> ();
  @Output () submit = new EventEmitter<boolean> ();

  showForgotPassword: boolean = false;

  landingPageHeaderHtmlSnippet: SafeHtml;
  landingPageFooterHtmlSnippet: SafeHtml;

  constructor ( private sanitizer: DomSanitizer ) {
  }

  ngOnInit (): void {
    if ( this.uiConfig?.landingPageHeaderHtmlSnippet ) {
      this.landingPageHeaderHtmlSnippet = this.sanitizer.bypassSecurityTrustHtml ( this.uiConfig?.landingPageHeaderHtmlSnippet );
    }
    if ( this.uiConfig?.landingPageFooterHtmlSnippet ) {
      this.landingPageFooterHtmlSnippet = this.sanitizer.bypassSecurityTrustHtml ( this.uiConfig?.landingPageFooterHtmlSnippet );
    }
  }

}
